import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireRole = 'user', allowedRoles = [] }) => {
    const { user, loading, isAdmin, isManager, isLegalProfessional } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
            </div>
        );
    }

    if (!user) {
        // Redirect to login page with return url
        return <Navigate to="/signin" state={{ from: location }} replace />;
    }

    // Check role-based access
    let hasAccess = false;
    
    // Check if using allowedRoles (array of roles) or requireRole (single role)
    if (allowedRoles && allowedRoles.length > 0) {
        // Check if user has any of the allowed roles
        if (allowedRoles.includes('admin') && isAdmin()) {
            hasAccess = true;
        } else if (allowedRoles.includes('manager') && isManager()) {
            hasAccess = true;
        } else if (allowedRoles.includes('legal_professional') && isLegalProfessional()) {
            hasAccess = true;
        } else if (allowedRoles.includes('user')) {
            hasAccess = true;
        }
    } else {
        // Use single role requirement (legacy support)
        switch(requireRole) {
            case 'admin':
                hasAccess = isAdmin();
                break;
            case 'manager':
                hasAccess = isManager();
                break;
            case 'legal_professional':
                hasAccess = isLegalProfessional();
                break;
            case 'user':
                // All authenticated users have access
                hasAccess = true;
                break;
            default:
                hasAccess = false;
        }
    }

    if (!hasAccess) {
        // Redirect to home page if user doesn't have required role
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute; 